<span [style.width.px]="width">
    <a href="javascript:void(0);" (click)="onClick()" style="color:#999999; text-decoration: underline;">{{value}}</a>
</span>
<img *ngIf="busy" src="{{localImageLocation}}ajax-loader.gif" class="link-busy" alt="loading">
